import { get } from '../../../utils/objectHelpers';
import { ajax } from '../../../utils/ajaxHandler';

export default class {
    onCreate(input) {
        this.input = input;
        const { isWatching } = input;
        this.state = {
            error: null,
            isWatching,
            watchLink: this.getWatchLink(),
            addWatchAjax: this.getAddWatchAjax(),
            removeWatchAjax: this.getRemoveWatchAjax()
        };
    }
    toggleWatch(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.getEl('watchBtn').style.display = 'none'; // Hide heart icon
        this.getEl('watchBtn').nextSibling.style.display = 'block'; // Show spinner
        const watchAjax = this.state.isWatching ? this.state.removeWatchAjax : this.state.addWatchAjax;
        ajax({
            url: watchAjax.url,
            responseType: 'json',
            withCredentials: false
        }, {
            successCallBack: this.handleWatchSuccess.bind(this),
            errorCallBack: this.handleWatchFailure.bind(this)
        });
    }
    handleWatchSuccess(response) {
        this.getEl('watchBtn').nextSibling.style.display = 'none'; // Hide spinner
        this.getEl('watchBtn').style.display = 'block'; // Show heart icon
        const ajaxResponse = response.status ? response : JSON.parse(response);
        if (ajaxResponse.status === 'Success' || ajaxResponse.result === 1) {
            this.state.isWatching = !this.state.isWatching;
        }
    }
    handleWatchFailure() {
        this.getEl('watchBtn').nextSibling.style.display = 'none'; // Hide spinner
        this.getEl('watchBtn').style.display = 'block'; // Show heart icon
    }
    getWatchLink() {
        const watch = get(this.input, 'watch', {});
        const watchLink = get(this.input, 'watch.action.URL', '');
        return {
            url: watchLink,
            tracking: this.getTracking(watch),
            title: this.getTitle(watch)
        };
    }
    getAddWatchAjax() {
        const watch = get(this.input, 'watch', {});
        const watchAddAjaxSrt = get(this.input, 'watchAddAjaxSrt', '');
        return {
            url: this.getUrl(watch, watchAddAjaxSrt),
            tracking: this.getTracking(watch),
            title: this.getTitle(watch)
        };
    }
    getRemoveWatchAjax() {
        const watching = get(this.input, 'watching', {});
        const watchDeleteAjaxSrt = get(this.input, 'watchDeleteAjaxSrt', '');
        return {
            url: this.getUrl(watching, watchDeleteAjaxSrt),
            tracking: this.getTracking(watching),
            title: this.getTitle(watching)
        };
    }
    getUrl(watchObject, token) {
        const url = get(watchObject, 'action.URL', '');
        return token ? `${url}&srt=${token}` : url;
    }
    getTracking(watchObject) {
        return JSON.stringify(get(watchObject, 'action.trackingList.0', {}));
    }
    getTitle(watchObject) {
        return get(watchObject, 'text.accessibilityText', '');
    }
}
